/**
 * GMA-1620 (CompassCare Web 5/14) — Clients route container.
 *
 * Mounts the app-shell (WebShell) around the Clients management page
 * (ClientsPage) at /web/clients, wiring sidebar navigation to the router. This
 * is the route scaffolding: the client-roster data plumbing (clients + their
 * living environment, devices, and contacts from the API) is a deliberate
 * follow-up, so until then the page renders its fail-safe empty roster inside a
 * real, navigable frame.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import WebShell from "../../components/web/WebShell";
import ClientsPage from "./ClientsPage";
import { DEMO_DATA_ENABLED, getDemoClients } from "./demoData";

export default function WebClientsRoute() {
  const navigate = useNavigate();
  // Capture one timestamp so demo-client generation and the `now` prop agree —
  // relative-time UI drifts if each call reads the clock separately.
  const now = Date.now();
  const clients = DEMO_DATA_ENABLED ? getDemoClients(now) : [];
  return (
    <WebShell
      activeKey="clients"
      onNavigate={(section) => {
        if (section && section.path) navigate(section.path);
      }}
      title="Clients"
    >
      <ClientsPage clients={clients} now={now} />
    </WebShell>
  );
}
